import map from 'lodash/map';

import { IconsEnum } from '../../../../assets/icons/types';
import { Currencies } from '../../../../types';

import {
  FETCH_CACHE_LAST_DEFAULT_CURRENCY_RATE_QUERY,
  FetchCacheLastDefaultCurrencyRateQueryResponse
} from '../../queries/fetchCacheLastDefaultCurrencyRate.query';

import { useCacheLastDefaultCurrencyRate } from '../../hooks/useCacheLastDefaultCurrencyRate';

import { Translate } from '../../../../helpers/Translate';
import { NumberHelper } from '../../../../helpers/NumberHelper';
import { TooltipIconButtonHelper } from '../../../../helpers/buttons/TooltipIconButtonHelper';

import { CurrencyRateCache } from '../../CurrencyRateCache';

import { currencyRatesKeys } from '../../../../locales/keys';

interface ExchangeRatesListTooltipIconButtonProps {
  currencies: Currencies[];
}

function ExchangeRatesListTooltipIconButton({
  currencies
}: ExchangeRatesListTooltipIconButtonProps) {
  const { lastDefaultCurrencyRate } =
    useCacheLastDefaultCurrencyRate<FetchCacheLastDefaultCurrencyRateQueryResponse>(
      {
        cacheKey: CurrencyRateCache.lastDefaultCacheKey(),
        query: FETCH_CACHE_LAST_DEFAULT_CURRENCY_RATE_QUERY
      }
    );

  return (
    <TooltipIconButtonHelper
      className="focus:ring-0"
      icon={IconsEnum.INFORMATION_CIRCLE_SOLID}
      iconClassName="h-4 w-4 text-gray-500"
      tooltipClassName="rounded-md bg-gray-200 dark:bg-gray-800 text-gray-900 dark:text-gray-200 border border-gray-300 dark:border-gray-700"
      tooltipChildren={
        <>
          <div className="text-sm mb-1">
            <strong>
              <Translate id={currencyRatesKeys.exchangeRate} />
            </strong>
          </div>
          {map(currencies, (currency) => (
            <div className="text-sm" key={currency}>
              <NumberHelper value={1} /> {currency} ={' '}
              <NumberHelper
                value={1 / (lastDefaultCurrencyRate?.data?.[currency] || 1)}
              />{' '}
              {Currencies.USD}
            </div>
          ))}
        </>
      }
    />
  );
}

export default ExchangeRatesListTooltipIconButton;
